module.exports = __webpack_public_path__ + "nagalogobig-565d604b.png";